import { Box, Typography } from '@mui/material';
import { Clock, Notepad } from 'phosphor-react';
import { useState } from 'react';
import { Note } from '../../Utilis/Types/Notes';
import { convertDate } from '../Strategies/TaskList';
import NotesModal from '../NotesModal';
type Props = {
  note: Note;
};
const NoteBox = ({ note }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getNoteIdFromNoteBody = (body: string) => {
    const includes = body.includes('workflows/');

    if (includes) {
      const regex = /<a href='\/workflows\/(\d+)'>/g;
      const match = regex.exec(body);

      if (match) {
        const matchedWorkflow = match?.[1];

        return body?.replace(
          regex,
          '<a href=/strategies/' + matchedWorkflow + '>'
        );
      }
    }
    return body;
  };

  return (
    <Box
      sx={{
        border: '1px solid #DBE0E2',
        background: '#fff',
        padding: '9.5px 12px',
        borderRadius: '4px',
        mb: '12px',
      }}
    >
      <NotesModal
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        note={note}
        getNoteIdFromNoteBody={getNoteIdFromNoteBody}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '9.5px',
        }}
      >
        <Typography
          fontSize={'16px'}
          lineHeight={'19px'}
          fontWeight={'600'}
          color={'#655C68'}
        >
          Note
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10.5px',
          }}
        >
          <Clock size={15} color='#655C68' />
          <Typography
            fontSize={'14px'}
            fontWeight={'400'}
            lineHeight={'19px'}
            color={'#655C68'}
          >
            {convertDate(note.updated_at)}
          </Typography>
        </Box>
      </Box>
      <Typography
        fontSize={'14px'}
        lineHeight={'19px'}
        fontWeight={'400'}
        color={'#736977'}
        marginBottom={'16px'}
        dangerouslySetInnerHTML={{
          __html: getNoteIdFromNoteBody(note?.body),
        }}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '36px',
          borderTop: ' 0.5px solid #DBE0E2 ',
          paddingTop: '4px',
        }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
          fontSize={'14px'}
          lineHeight={'17px'}
          fontWeight={'500'}
          color={'#655C68'}
        >
          <Notepad size={13} color={'#655C68'} />
          {note.category}
        </Typography>
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer',
          }}
          fontSize={'14px'}
          lineHeight={'17px'}
          fontWeight={'500'}
          color={'#655C68'}
          onClick={() => setIsModalOpen(true)}
        >
          Comments ({note.comments.length})
        </Typography>
      </Box>
    </Box>
  );
};

export default NoteBox;
